import { render } from "./ordentrabajoresultadopoliza.vue?vue&type=template&id=186556b9&scoped=true"
import script from "./ordentrabajoresultadopoliza.vue?vue&type=script&lang=js"
export * from "./ordentrabajoresultadopoliza.vue?vue&type=script&lang=js"

import "./ordentrabajoresultadopoliza.vue?vue&type=style&index=0&id=186556b9&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186556b9"]])

export default __exports__